import { ArticleType } from "@/@types/BlogArticle";
import { textEllipsisOverflow } from "@/utils/common-functions";
import { otherBlogs } from "@/utils/content";
import { routes } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Card } from "reactstrap";

interface FeaturedGridProps {
  article: ArticleType;
  classes: any;
}

const FeaturedGrid = ({ article, classes }: FeaturedGridProps) => {
  const { title, date, category, id, localImageURL } = article;

  const content = otherBlogs.en;
  return (
    <Card className={classes.card}>
      <Link href={`${routes.blog}/${id}`}>
        <div className="text-center">
          <Image
            src={
              localImageURL
                ? localImageURL
                : "/images/newsroom/image-na-card.png"
            }
            className="img-fluid"
            alt="blog article illustration"
            height={400}
            width={400}
            style={{
              width: "100%",
              height: "auto",
              minHeight: "250px",
            }}
          />
        </div>
        <div className={classes.cardBody}>
          <div className="date">{date}</div>
          <p className="fw-bold">{textEllipsisOverflow(title, 50)}</p>
          <p className="category">
            {textEllipsisOverflow(category ? category : content.noCategory, 70)}
          </p>
        </div>
      </Link>
    </Card>
  );
};

export default FeaturedGrid;
